import axios from 'axios'

const BASE = (process.env.REACT_APP_API_BASEURL || '').replace(/\/+$/, '')
const visibilities = new Set(['ENABLED', 'HIDDEN', 'RESTRICTED', 'COMMERCIAL'])
const isText = (value) => typeof value === 'string' && value.trim().length > 0
const isOptionalText = (value) => value === null || typeof value === 'string'

export function parseNavigation(response) {
  const invalid = () => { throw new Error('La respuesta de navegación no es válida.') }
  if (!response || !isOptionalText(response.activeRole) || !isOptionalText(response.profileLabel) ||
      !isOptionalText(response.tenantId) || !Array.isArray(response.sections)) invalid()

  const codes = new Set()
  const readEntries = (entries) => entries.map((entry) => {
    if (!entry || !isText(entry.code) || codes.has(entry.code) || !isText(entry.label) ||
        !isText(entry.visibility) || !isOptionalText(entry.restrictionReason) || !Array.isArray(entry.children)) invalid()
    codes.add(entry.code)
    return {
      ...entry,
      visibility: visibilities.has(entry.visibility) ? entry.visibility : 'HIDDEN',
      children: readEntries(entry.children),
    }
  })
  const sectionCodes = new Set()
  const sections = response.sections.map((section) => {
    if (!section || !isText(section.code) || sectionCodes.has(section.code) || !isText(section.label) ||
        !Number.isFinite(section.displayOrder) || !Array.isArray(section.items)) invalid()
    sectionCodes.add(section.code)
    return { ...section, items: readEntries(section.items) }
  })
  if (!response.activeRole && sections.some((section) => section.items.length)) invalid()
  return { ...response, sections }
}

export async function fetchNavigation(token, signal) {
  const { data } = await axios.get(`${BASE}/users/me/navigation`, {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
    timeout: 20000,
    signal,
  })
  return parseNavigation(data)
}
